module.exports = __webpack_public_path__ + "media/everyday-health-85d188cc.svg";